import "../styles/call-back.css";
import { useState, useEffect } from "react";
import UserController from "../services/user-controller";

export default function CallBackMembership(props) {
	const [isLoading, setIsLoading] = useState(true);
	const [order, setOrder] = useState({
		isPayed: false,
		orderNumber: "",
		trackingNumber: "",
		paymentDate: null,
		totalCost: 0,
	});
	const [profile, setProfile] = useState({ decile: 0, levelName: "" });
	const [errorMessage, setErrorMessage] = useState("");
	//
	const userController = new UserController();

	useEffect(() => {
		getData();
	}, []);

	const getData = async function () {
		try {
			if (window.isBusy === true) return;
			window.isBusy = true;
			setErrorMessage("");
			const queryParams = new URLSearchParams(window.location.href.split("?")[1]);
			var orderResult = await userController.getOrder(
				queryParams.get("orderNumber")
			);
			if (orderResult.isSuccess === false) throw orderResult.message;
			setOrder(orderResult.value);
			//
			var profileResult = await userController.getProfile();
			if (profileResult.isSuccess === false) throw profileResult.message;
			setProfile(profileResult.value);
		} catch (error) {
			setErrorMessage(error.toString());
		}
		window.isBusy = false;
		setIsLoading(false);
	};

	return (
		<article className="call-back">
			{isLoading === true && (
				<div>
					<h2>لطفا منتظر بمانید...</h2>
				</div>
			)}
			{isLoading === false && errorMessage && <p className="cb-error">{errorMessage}</p>}
			{isLoading === false && !errorMessage && (
				<>
					{order.isPayed === false && (
						<div className="cb-failed">
							<h2>پرداخت ناموفق</h2>
							<p>سفارش شما با شماره {order.orderNumber} پرداخت نشده است</p>
						</div>
					)}
					{order.isPayed === true && (
						<div class="cb-success">
							<h2>پرداخت موفق</h2>
							<p>حق عضویت شما با موفقیت پرداخت و عضویت شما فعال شد</p>
							<ul>
								<li>
									<label>شماره سفارش</label>
									<i></i>
									<b>{order.orderNumber}</b>
								</li>
								<li>
									<label>شماره پیگیری</label>
									<i></i>
									<b>{order.trackingNumber}</b>
								</li>
								<li>
									<label>تاریخ پرداخت</label>
									<i></i>
									<b>
										{new Date(order.paymentDate)?.toLocaleString("fa-IR").replace(",", " ساعت ")}
									</b>
								</li>
								<li>
									<label>هزینه پرداختی</label>
									<i></i>
									<b>{order.totalCost?.toLocaleString("en-US")} ریال</b>
								</li>
								<li>
									<label>دهک شما</label>
									<i></i>
									<b>{profile.decile}</b>
								</li>
								<li>
									<label>سطح شما در باشگاه مشتریان</label>
									<i></i>
									<b>{profile.levelName}</b>
								</li>
							</ul>
						</div>
					)}
				</>
			)}
		</article>
	);
}
